module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4",
    attrs: {
      "icon": "factory"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('span', [_vm._v("Installation")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "px-4 pb-6",
    attrs: {
      "back": {
        name: 'liste-installations'
      }
    }
  }, [(_vm.typeUser === 'technicien') ? _c('router-link', {
    staticClass: "bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium text-right",
    attrs: {
      "id": "install_intervenant_btn",
      "to": {
        name: 'new-fibsdd',
        query: {
          detenteur: _vm.$route.params.id,
          installation: _vm.$route.params.idInst
        }
      }
    }
  }, [_c('strong', [_vm._v("Intervenir")]), _c('br'), _vm._v("sur l'installation\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-lg overflow-hidden mb-30"
  }, [_c('div', {
    staticClass: "bg-white p-4"
  }, [(_vm.installation.i_tag !== null || _vm.optionForceOtag === true) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('router-link', {
    staticClass: "px-3 py-2 text-white rounded-xl flex items-center justify-between shadow-lg",
    class: _vm.installation.fluide !== null ? 'bg-otag-install' : 'bg-otag-install',
    attrs: {
      "to": {
        name: 'information-installation'
      }
    }
  }, [_c('h2', {
    staticClass: "text-sm font-semibold uppercase"
  }, [_vm._v("\n                            Informations complémentaires\n                            "), (_vm.installation.fluide !== null) ? [_vm._v("\n                                (DESP, Maintenance préventive, Attestation Entretien)\n                            ")] : [_vm._v("\n                                (Maintenance préventive)\n                            ")]], 2), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-info bg-white opacity-50"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "map",
    staticClass: "hidden",
    staticStyle: {
      "height": "210px",
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "space-y-4",
    attrs: {
      "method": "post",
      "id": "installation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [(_vm.installation.i_tag !== null) ? _c('div', [_c('label', {
    staticClass: "label m-0"
  }, [_vm._v("OTAG INSTALL")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.i_tag),
      expression: "installation.i_tag",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input flex-1",
    attrs: {
      "title": "installItag",
      "type": "text",
      "name": "itag",
      "maxlength": "255",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.installation.i_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "i_tag", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "input bg-otag-install text-white uppercase font-semibold inline-flex items-center justify-center !w-auto whitespace-nowrap",
    attrs: {
      "id": "change-itag",
      "href": ("fi360://scan?success=tryGoToInstall&idInst=" + (_vm.$route.params.idInst) + "&idDet=" + (_vm.$route.params.id))
    }
  }, [_vm._v("\n                                Changer l'otag install\n                            ")])])]) : _c('div', [_c('a', {
    staticClass: "px-3 py-2 bg-otag-install text-white rounded-xl flex items-center justify-between shadow-lg",
    attrs: {
      "href": ("fi360://scan?success=tryGoToInstall&idInst=" + (_vm.$route.params.idInst) + "&idDet=" + (_vm.$route.params.id)),
      "id": "add-itag"
    }
  }, [_c('h2', {
    staticClass: "text-md font-semibold uppercase"
  }, [_vm._v("Ajouter une Otag install")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-12 w-12 mask mask-otag-install bg-white opacity-50"
  })])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "nom"
    }
  }, [_vm._v("Nom de l'installation "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.nom),
      expression: "installation.nom",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input flex-1",
    attrs: {
      "title": "installName",
      "type": "text",
      "name": "nom",
      "id": "nom",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "nom", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.optionBarcode === true) ? _c('a', {
    staticClass: "bg-secondary text-white p-1 ml-2 rounded flex items-center justify-center",
    attrs: {
      "href": "fi360://scan?success=fillCodeBarre&type=installation",
      "id": "barcode-scan"
    }
  }, [_c('i', {
    staticClass: "h-8 w-8 mask mask-scan-barcode bg-white"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "marque"
    }
  }, [_vm._v("Marque "), (!_vm.gotFluide) ? _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.marque),
      expression: "installation.marque",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "marque",
      "type": "text",
      "id": "marque",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.marque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "marque", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "modele"
    }
  }, [_vm._v("Modèle / N° de série / Repère "), (!_vm.gotFluide) ? _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.modele),
      expression: "installation.modele",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "model",
      "type": "text",
      "id": "modele",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.modele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "modele", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "px-3 py-2 bg-primary text-white rounded-xl flex items-center justify-between shadow-lg cursor-pointer",
    attrs: {
      "id": "install_btn_photo"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.photoInstall.click()
      }
    }
  }, [_c('h2', {
    staticClass: "text-md font-semibold uppercase"
  }, [_vm._v("\n                                PHOTO INSTALLATION OU PLAQUE SIGNALETIQUE\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-photo bg-white opacity-50"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "photoInstall",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handlePhotoInstall
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.urlPhoto !== null),
      expression: "urlPhoto !== null"
    }],
    staticClass: "mt-4 flex justify-center"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "icon icon-delete absolute -top-2 -right-2 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.installation.photo = null
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.urlPhoto,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "max-h-64 rounded shadow",
    attrs: {
      "src": _vm.urlPhoto,
      "alt": "photo installation",
      "id": "photo-install"
    }
  })])])])]), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "space-y-4"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type de fluide "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), (_vm.installation.fluide) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.fluide),
      expression: "installation.fluide"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "fluide", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateComputed]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Sélectionnez un fluide")]), _vm._v(" "), _vm._l((_vm.fluides), function(fluide) {
    return _c('option', {
      key: fluide.id,
      domProps: {
        "value": fluide
      }
    }, [_vm._v("\n                                    " + _vm._s(fluide.nom) + _vm._s(fluide.nom_commercial ? ' - ' + fluide.nom_commercial : '') + "\n                                ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "charge_totale"
    }
  }, [_vm._v("Charge totale (Kg) "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.installation.charge),
      expression: "installation.charge",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "chargeTotal",
      "type": "number",
      "name": "charge_totale",
      "min": "0.010",
      "step": "0.001",
      "id": "charge_totale"
    },
    domProps: {
      "value": (_vm.installation.charge)
    },
    on: {
      "change": _vm.updateComputed,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "charge", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Détecteur de fuite fixe "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('label', {
    staticClass: "inline-flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    staticClass: "hidden peer",
    attrs: {
      "name": "detecteur_fuite_fixe",
      "type": "radio",
      "id": "fuite_ok"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.detecteur, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "fuite_ok"
    }
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('label', {
    staticClass: "inline-flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    staticClass: "hidden peer",
    attrs: {
      "name": "detecteur_fuite_fixe",
      "type": "radio",
      "id": "fuite_ko"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.detecteur, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success",
    attrs: {
      "for": "fuite_ko"
    }
  }, [_vm._v("Non")])])])]), _vm._v(" "), (_vm.canForceFrequence === true) ? _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Fréquence de contrôle forcée")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-4 mt-3"
  }, [_c('label', {
    staticClass: "inline-flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    staticClass: "hidden peer",
    attrs: {
      "name": "force_frequence",
      "type": "radio",
      "id": "force_frequence"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.force_frequence, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('label', {
    staticClass: "inline-flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    staticClass: "hidden peer",
    attrs: {
      "name": "force_frequence",
      "type": "radio",
      "id": "force_frequence_no"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.force_frequence, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
  }, [_vm._v("Non")])])]), _vm._v(" "), (_vm.installation.force_frequence === true) ? _c('div', {
    staticClass: "my-4"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "frequence_controle"
    }
  }, [_vm._v("Fréquence de contrôle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.frequence_controle),
      expression: "installation.frequence_controle"
    }],
    staticClass: "input",
    attrs: {
      "name": "frequence_controle",
      "id": "frequence_controle"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "frequence_controle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24 mois")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fluideIsFibsdd),
      expression: "fluideIsFibsdd"
    }],
    staticClass: "space-y-1 leading-tight"
  }, [(_vm.installation.fluide !== null && _vm.installation.fluide.type !== 'HFO') ? _c('p', {
    staticClass: "!my-0"
  }, [_vm._v("\n                                Tonnage équivalent CO"), _c('span', {
    staticClass: "smallexp"
  }, [_vm._v("2")]), _vm._v(" :\n                                "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "tonnage"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.tonnage)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "!my-0"
  }, [_vm._v("\n                                GWP :\n                                "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "gwp"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.fluide.gwp)
    }
  })]), _vm._v(" "), (_vm.installation.fluide && _vm.installation.fluide.type !== 'CFC') ? _c('p', {
    staticClass: "!my-0"
  }, [_vm._v("\n                                Fréquence de contrôle\n                                "), (_vm.installation.force_frequence === true) ? _c('span', {
    staticClass: "font-bold"
  }, [_vm._v("forcée")]) : _vm._e(), _vm._v("\n                                de l'installation :\n                                "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "frequence"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.installation.frequence_controle === 0 || _vm.installation.frequence_controle ==
    null ? 'Aucune' :
    _vm.installation.frequence_controle + ' Mois') + "\n                                ")])]) : _vm._e(), _vm._v(" "), (_vm.installation.file_notice && _vm.installation.file_notice !== null) ? _c('p', {
    staticClass: "!my-0",
    attrs: {
      "id": "install_notice_block"
    }
  }, [_c('a', {
    staticClass: "px-3 py-2 bg-primary text-white rounded-xl inline-flex items-center gap-2 shadow-lg",
    attrs: {
      "href": _vm.getUrlNotice,
      "target": "_blank",
      "id": "install_notice_link"
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-file bg-white opacity-50"
  }), _vm._v(" "), _c('span', [_vm._v("Notice de l'installation")])])]) : _vm._e(), _vm._v(" "), (_vm.installation.last_control != null) ? _c('p', {
    staticClass: "!my-0"
  }, [_vm._v("\n                                Date du dernier contrôle périodique :\n                                "), _c('span', {
    staticClass: "text-secondary font-bold",
    attrs: {
      "id": "dateLastControl"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm._f("dateFormat")(_vm.installation.last_control, 'DD/MM/YYYY')) + "\n                                ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.canEditInstallations) ? _c('input', {
    staticClass: "btn-primary",
    attrs: {
      "type": "submit",
      "id": "submit-install",
      "name": "new",
      "value": "SAUVEGARDER"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.fis.length !== 0) ? _c('div', {
    staticClass: "mt-6 bg-gris-bleu rounded-lg shadow overflow-hidden mb-25"
  }, [_c('h3', {
    staticClass: "text-xl text-primary font-normal p-3"
  }, [_vm._v("REGISTRE DES INTERVENTIONS")]), _vm._v(" "), _c('table', {
    staticClass: "w-full border-collapse bg-white"
  }, [_c('tbody', _vm._l((_vm.fis.slice().reverse()), function(fi) {
    return _c('tr', {
      key: fi.id,
      staticClass: "border-y border-gray-200 odd:bg-[#F7F9FC]"
    }, [_c('td', [_c('div', {
      staticClass: "p-3 text-left flex items-center space-x-4"
    }, [_c('p', {
      staticClass: "text-md"
    }, [_vm._v(_vm._s(fi.dateToShow))]), _vm._v(" "), _c('a', {
      staticClass: "text-md font-bold text-secondary",
      attrs: {
        "href": fi.isFibsdd === true ? ((_vm.Config.urlAdmin) + "/pdf/fiche/" + (fi.id) + "?token=" + _vm.token) : ((_vm.Config.urlAdmin) + "/pdf/externalFile/" + (fi.id) + "?token=" + _vm.token),
        "target": "_blank"
      }
    }, [_vm._v("\n                                        " + _vm._s(fi.isFibsdd === true ? fi.numero : fi.name) + "\n                                    ")]), _vm._v(" "), (fi.isFibsdd === true && fi.intervention_controle_p === true) ? _c('p', {
      staticClass: "text-md italic text-gray-500"
    }, [_vm._v("\n                                        Contrôle périodique\n                                    ")]) : _vm._e()])])])
  }), 0)])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27886e7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/Installation.vue
// module id = 1019
// module chunks = 0